import { Status } from "../../graphql/generated";
import i18next from "i18next";

const statusLabel = (status: Status) => {
  // @ts-expect-error
  return (i18next.t(`orders:statusEnum.${status}`) as string).toUpperCase();
};

export default statusLabel;
